import BaseComponent from 'foundation/base-component';
import { NewsFeedService } from 'general/js/services';

class NewsFeedLiveSelector extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.state = {
        };
        this.init();
    }

    static getRequiredRefs() {
        return ['input'];
    }

    init() {
        this.onInputChange();
        this.addListener(this.refs.input, 'change', this.onInputChange);
    }

    onInputChange = () => {
        if (this.refs.input.checked) {
            NewsFeedService.add(this.refs.input.value);
        } else {
            NewsFeedService.remove(this.refs.input.value);
        }
    }
}

export default NewsFeedLiveSelector;
